export default __webpack_public_path__ + "d7c11259b93947b532ff68451902e52a.png";